export default __webpack_public_path__ + "static/media/liquidity.4bb81014.png";